<template>
   <!-- There should never be a case where there is no signup policy because a default will be seeded -->
   <!-- Because of this, the whole tickbox being missing where this doesn't exist should & will prevent sign ups -->
   <div v-if="signupPolicy" data-cy="signup-policy-sect" class="signup-policy">
      <div class="flex items-center">
         <CustomCheckbox
            v-model="state.agreedToSignupPolicy"
            class="mb-8"
            label="terms-privacy-checkbox"
            hideLabel
            :errorStyle="showError"
            @change="onChange"
         />
         <label for="terms-privacy-checkbox" class="policy-text">
            <RichTextRenderer :document="signupPolicy" />
         </label>
      </div>

      <SnAlert
         v-if="signupPolicyErrorMsg"
         data-cy="terms-privacy-checkbox-error-mustBeTrue"
         :message="signupPolicyErrorMsg"
         id="signup-policy-validation-message"
         theme="danger"
         size="small"
         class="validation-alert"
         icon="warning-circle-filled"
      />
   </div>
</template>

<script setup lang="ts">
import SnAlert from "@sano-ui-library/src/ui/SnAlert/SnAlert.vue";
import { useI18n } from "@/vue-i18n/vue-i18n";

const $emit = defineEmits(["change"]);
const { t: $t } = useI18n();

const state = ref({
   agreedToSignupPolicy: false,
});

const props = defineProps<{
   signupPolicy?: any;
   showError?: boolean;
}>();

const signupPolicyErrorMsg = computed(() => {
   // submit was triggered in parent and user has not agreed to the signup policy
   if (props.showError && !state.value.agreedToSignupPolicy) {
      return $t("authentication.signup_policy_agreement");
   }
   return null;
});

// methods
// ----------------------------------------
function onChange(event) {
   $emit("change", state.value.agreedToSignupPolicy);
}
</script>

<style lang="css" scoped>
.policy-text {
   margin-inline-start: var(--size-base-8);
   text-align: left;
   font-size: var(--size-text-small);
   line-height: 1.3;
   color: var(--grey-80);
   font-weight: var(--weight-base);
}

.signup-policy {
   text-align: left;
}
</style>
